import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

interface Props {
  id: string;
  title: string;
  show: boolean;
  onShowClick: (key: string, show: boolean) => void;
}

export function SortableItem({ id, title, show, onShowClick }: Props) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="card"
      {...attributes}
      {...listeners}
    >
      <div className="card-children-group__wrapper">
        <div className="card__icon">
          <i className="bi bi-arrows-move" />
        </div>
        <div className={show ? "" : "text_strike-through"}>{title}</div>
      </div>
      <div className="card-hide__button" onClick={() => onShowClick(id, !show)}>
        <i className={`bi ${show ? "bi-eye" : "bi-eye-slash"}`} />
      </div>
    </div>
  );
}
